import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: clamp(2rem, 5vw, 4rem) 1.5rem;
  width: 100%;
`;

interface HomeLayoutProps {
  children: React.ReactNode;
}

const HomeLayout: React.FC<HomeLayoutProps> = ({ children }) => {
  return (
    <Container>
      {children}
    </Container>
  );
};

export default HomeLayout; 